// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Box } from '@mui/material';

// props
export interface BoxDescriptionProps {
	description: null | string | undefined;
}

export const BoxDescription = ({ description }: BoxDescriptionProps) => {
	// hooks
	const { t } = useTranslation();

	return (
		<Box
			sx={(theme) => {
				return {
					padding: {
						xs: theme.spacing(2),
						md: theme.spacing(3),
					},
					maxWidth: {
						lg: 800,
					},
				};
			}}>
			{description || t('noDescriptionProvided')}
		</Box>
	);
};
